import React, { useState } from 'react';
// Territory data structure
const territoryData = {
  global: ['Worldwide', 'Worldwide excluding USA', 'Worldwide excluding USA & Canada', 'Worldwide excluding sanctioned countries', 'Global (Specified Territories)', 'International (Non-Domestic)'],
  regions: {
    'North America': {
      regions: ['North America', 'USA & Canada', 'Continental United States', 'United States (All States)', 'United States (Admitted)', 'United States (Non-Admitted / Surplus Lines)', 'Caribbean'],
      countries: ['United States', 'Canada', 'Mexico', 'Bermuda', 'Cayman Islands', 'Bahamas', 'Barbados', 'Jamaica', 'Trinidad & Tobago', 'Puerto Rico', 'US Virgin Islands']
    },
    'Latin America': {
      regions: ['Latin America', 'Central America', 'South America'],
      countries: ['Argentina', 'Bolivia', 'Brazil', 'Chile', 'Colombia', 'Costa Rica', 'Dominican Republic', 'Ecuador', 'El Salvador', 'Guatemala', 'Honduras', 'Nicaragua', 'Panama', 'Paraguay', 'Peru', 'Uruguay', 'Venezuela']
    },
    Europe: {
      regions: ['Europe', 'European Union (EU)', 'EEA (European Economic Area)', 'UK & Ireland', 'Western Europe', 'Northern Europe', 'Southern Europe', 'Central Europe', 'Eastern Europe', 'EU (Excluding UK)', 'Non-EU Europe'],
      countries: ['United Kingdom', 'Ireland', 'France', 'Germany', 'Italy', 'Spain', 'Portugal', 'Netherlands', 'Belgium', 'Luxembourg', 'Switzerland', 'Austria', 'Denmark', 'Sweden', 'Norway', 'Finland', 'Iceland', 'Poland', 'Czech Republic', 'Slovakia', 'Hungary', 'Romania', 'Bulgaria', 'Greece', 'Croatia', 'Slovenia', 'Serbia', 'Bosnia & Herzegovina', 'Montenegro', 'North Macedonia', 'Albania', 'Estonia', 'Latvia', 'Lithuania', 'Ukraine', 'Moldova', 'Belarus', 'Russia', 'Turkey']
    },
    'Middle East': {
      regions: ['Middle East', 'Gulf Cooperation Council (GCC)', 'MENA (Middle East & North Africa)'],
      countries: ['United Arab Emirates', 'Saudi Arabia', 'Qatar', 'Kuwait', 'Bahrain', 'Oman', 'Israel', 'Jordan', 'Lebanon', 'Egypt', 'Iraq', 'Iran', 'Yemen']
    },
    Africa: {
      regions: ['Africa', 'North Africa', 'Sub-Saharan Africa', 'West Africa', 'East Africa', 'Southern Africa'],
      countries: ['South Africa', 'Nigeria', 'Ghana', 'Kenya', 'Uganda', 'Tanzania', 'Rwanda', 'Ethiopia', 'Morocco', 'Algeria', 'Tunisia', 'Egypt', 'Senegal', 'Ivory Coast', 'Angola', 'Namibia', 'Botswana', 'Zambia', 'Zimbabwe', 'Mozambique']
    },
    Asia: {
      regions: ['Asia', 'East Asia', 'South Asia', 'Southeast Asia (ASEAN)', 'Central Asia', 'Asia-Pacific (APAC)', 'Asia excluding Japan', 'Asia excluding China'],
      countries: ['China', 'Hong Kong', 'Macau', 'Japan', 'South Korea', 'Taiwan', 'India', 'Pakistan', 'Bangladesh', 'Sri Lanka', 'Nepal', 'Thailand', 'Singapore', 'Malaysia', 'Indonesia', 'Vietnam', 'Philippines', 'Cambodia', 'Laos', 'Myanmar', 'Mongolia', 'Kazakhstan', 'Uzbekistan']
    },
    Oceania: {
      regions: ['Oceania', 'Australasia', 'Pacific Islands'],
      countries: ['Australia', 'New Zealand', 'Papua New Guinea', 'Fiji', 'Solomon Islands']
    }
  },
  special_insurance_categories: ['Sanctioned Countries (Excluded)', 'OFAC-Restricted Territories', 'High-Risk Jurisdictions', 'Offshore Financial Centres', 'Tax-Neutral Jurisdictions', 'Non-OECD Countries', 'OECD Countries', 'Emerging Markets', 'Frontier Markets']
};
// Line of Business taxonomy
const lineOfBusinessData = {
  'Property & Casualty': {
    fca_classes: ['Class 8 – Fire and Natural Forces', 'Class 9 – Other Damage to Property', 'Class 10 – Motor Vehicle Liability', 'Class 11 – Aircraft Liability', 'Class 12 – Liability for Ships', 'Class 13 – General Liability', 'Class 16 – Miscellaneous Financial Loss'],
    lines: {
      Property: ['Commercial Property', 'Residential Property', 'Industrial Property', 'Builders Risk', 'Property All Risks', 'Fire and Allied Perils', 'Inland Marine', 'Equipment Breakdown', 'Terrorism Property', 'Parametric Property'],
      'Casualty & Liability': ['Commercial General Liability', 'Public Liability', 'Products Liability', 'Completed Operations', "Employers' Liability", 'Environmental / Pollution Liability', 'Excess Liability', 'Umbrella Liability'],
      Motor: ['Commercial Motor', 'Private Motor', 'Fleet', 'Non-Owned Motor', 'Hired Motor', 'Motor Truck Cargo', 'Garage Liability']
    }
  },
  Specialty: {
    fca_classes: ['Class 13 – General Liability', 'Class 14 – Credit', 'Class 15 – Suretyship', 'Class 16 – Miscellaneous Financial Loss'],
    lines: {
      'Financial Lines': ['Directors and Officers Liability (D&O)', 'Professional Indemnity / Errors and Omissions', 'Medical Malpractice', 'Cyber Liability', 'Technology E&O', 'Media Liability', 'Employment Practices Liability', 'Crime / Fidelity', 'Kidnap and Ransom', 'Transactional Risk (Warranty & Indemnity)'],
      'Specialty Casualty': ['Construction Liability', 'Energy Liability', 'Oil and Gas Liability', 'Aviation Liability', 'Marine Liability', 'Rail Liability', 'Product Recall', 'Contingency / Event Cancellation', 'Excess and Surplus Lines'],
      'Political & Credit Risk': ['Political Risk', 'Trade Credit', 'Political Violence', 'Standalone Terrorism']
    }
  },
  'Marine & Aviation': {
    fca_classes: ['Class 6 – Ships', 'Class 7 – Goods in Transit', 'Class 11 – Aircraft Liability', 'Class 12 – Liability for Ships'],
    lines: {
      Marine: ['Marine Cargo', 'Hull and Machinery', 'Protection and Indemnity (P&I)', 'Marine War', 'Yacht Insurance'],
      Aviation: ['Aviation Hull', 'Aviation Liability', 'Airport Operators Liability', 'Aviation Products Liability']
    }
  },
  Life: {
    fca_classes: ['Class 1 – Life and Annuity'],
    lines: ['Term Life', 'Whole Life', 'Universal Life', 'Variable Life', 'Indexed Universal Life', 'Group Life', 'Key Person Life', 'Mortgage Protection Life', 'Accidental Death and Dismemberment']
  },
  'Health & Accident': {
    fca_classes: ['Class 1 – Accident', 'Class 2 – Sickness'],
    lines: {
      Health: ['Individual Health', 'Group Health', 'Major Medical', 'Supplemental Health', 'International Health'],
      'Accident & Health': ['Personal Accident', 'Travel Medical', 'Disability Income', 'Short-Term Disability', 'Long-Term Disability', 'Critical Illness', 'Hospital Indemnity', 'Dental', 'Vision']
    }
  },
  'Surety & Bonds': {
    fca_classes: ['Class 15 – Suretyship'],
    lines: ['Contract Surety', 'Commercial Surety', 'Judicial Bonds', 'License and Permit Bonds', 'Customs Bonds', 'Fidelity Bonds']
  },
  'Personal Lines': {
    fca_classes: ['Class 3 – Land Vehicles', 'Class 8 – Fire and Natural Forces', 'Class 9 – Other Damage to Property', 'Class 16 – Miscellaneous Financial Loss'],
    lines: ['Homeowners', 'Renters', 'Condominium', 'Personal Motor', 'Personal Umbrella', 'High Net Worth', 'Valuable Articles', 'Travel Insurance', 'Pet Insurance']
  },
  'Emerging & Specialty Risks': {
    fca_classes: ['Class 16 – Miscellaneous Financial Loss'],
    lines: ['Parametric Insurance', 'Embedded Insurance', 'Usage-Based Insurance', 'Microinsurance', 'Climate and Weather Risk', 'Digital Asset Insurance', 'Crypto Custody Insurance']
  }
};
export function MGAInformation() {
  const [businessType, setBusinessType] = useState<'Program' | 'MGA'>('MGA');
  const [status, setStatus] = useState<'New' | 'Existing' | 'Transfer'>('New');
  const [territory, setTerritory] = useState('');
  const [mgaPercentage, setMgaPercentage] = useState(25);
  const [brokerPercentage, setBrokerPercentage] = useState(15);
  const [selectedLineOfBusiness, setSelectedLineOfBusiness] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  // Get available classes based on selected line of business
  const getAvailableClasses = () => {
    if (!selectedLineOfBusiness) return [];
    const lobData = lineOfBusinessData[selectedLineOfBusiness as keyof typeof lineOfBusinessData];
    if (!lobData) return [];
    const classes: string[] = [];
    // Add FCA classes
    if (lobData.fca_classes) {
      classes.push(...lobData.fca_classes);
    }
    // Add lines (either array or nested object)
    if (Array.isArray(lobData.lines)) {
      classes.push(...lobData.lines);
    } else if (typeof lobData.lines === 'object') {
      Object.entries(lobData.lines).forEach(([category, items]) => {
        classes.push(`--- ${category} ---`);
        classes.push(...items);
      });
    }
    return classes;
  };
  return <div className="bg-white rounded-lg shadow p-6 max-w-3xl" data-id="element-2411">
      <h2 className="text-xl font-semibold mb-6" data-id="element-2412">MGA Information</h2>

      <div className="space-y-6" data-id="element-2413">
        {/* Business Type and Status - Side by Side */}
        <div className="grid md:grid-cols-2 gap-6" data-id="element-2414">
          {/* Business Type Selection */}
          <div data-id="element-2415">
            <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-2416">
              Business Type
            </label>
            <div className="flex gap-6" data-id="element-2417">
              <label className="flex items-center cursor-pointer group" data-id="element-2418">
                <input type="radio" name="businessType" value="Program" checked={businessType === 'Program'} onChange={e => setBusinessType(e.target.value as 'Program' | 'MGA')} className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2419" />
                <span className="ml-2 text-sm text-gray-700 group-hover:text-gray-900 font-medium" data-id="element-2420">
                  Program
                </span>
              </label>

              <label className="flex items-center cursor-pointer group" data-id="element-2421">
                <input type="radio" name="businessType" value="MGA" checked={businessType === 'MGA'} onChange={e => setBusinessType(e.target.value as 'Program' | 'MGA')} className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2422" />
                <span className="ml-2 text-sm text-gray-700 group-hover:text-gray-900 font-medium" data-id="element-2423">
                  MGA
                </span>
              </label>
            </div>
          </div>

          {/* Status Dropdown */}
          <div data-id="element-2424">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2425">
              Status
            </label>
            <select value={status} onChange={e => setStatus(e.target.value as 'New' | 'Existing' | 'Transfer')} className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-2426">
              <option value="New" data-id="element-2427">New</option>
              <option value="Existing" data-id="element-2428">Existing</option>
              <option value="Transfer" data-id="element-2429">Transfer</option>
            </select>
          </div>
        </div>

        {/* Territory Selection */}
        <div data-id="element-2430">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2431">
            Territory
          </label>
          <select value={territory} onChange={e => setTerritory(e.target.value)} className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-2432">
            <option value="" data-id="element-2433">Select a territory</option>

            {/* Global Options */}
            <optgroup label="Global Coverage" data-id="element-2434">
              {territoryData.global.map(item => <option key={item} value={item} data-id="element-2435">
                  {item}
                </option>)}
            </optgroup>

            {/* Regional Options */}
            {Object.entries(territoryData.regions).map(([regionName, regionData]) => <optgroup key={regionName} label={regionName} data-id="element-2436">
                  {regionData.regions.map(region => <option key={region} value={region} data-id="element-2437">
                      {region}
                    </option>)}
                  {regionData.countries.map(country => <option key={country} value={country} data-id="element-2438">
                      {country}
                    </option>)}
                </optgroup>)}

            {/* Special Insurance Categories */}
            <optgroup label="Special Categories" data-id="element-2439">
              {territoryData.special_insurance_categories.map(category => <option key={category} value={category} data-id="element-2440">
                  {category}
                </option>)}
            </optgroup>
          </select>
        </div>

        {/* MGA Percentage */}
        <div data-id="element-2441">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2442">
            {businessType} % of premium: {mgaPercentage}%
          </label>
          <div className="flex items-center gap-4" data-id="element-2443">
            <input type="range" min="0" max="100" value={mgaPercentage} onChange={e => setMgaPercentage(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-2444" />
            <input type="number" min="0" max="100" value={mgaPercentage} onChange={e => setMgaPercentage(parseInt(e.target.value))} className="w-20 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-2445" />
          </div>
        </div>

        {/* Broker Percentage */}
        <div data-id="element-2446">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2447">
            Broker % of premium: {brokerPercentage}%
          </label>
          <div className="flex items-center gap-4" data-id="element-2448">
            <input type="range" min="0" max="100" value={brokerPercentage} onChange={e => setBrokerPercentage(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-2449" />
            <input type="number" min="0" max="100" value={brokerPercentage} onChange={e => setBrokerPercentage(parseInt(e.target.value))} className="w-20 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-2450" />
            <button className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 transition-colors" data-id="element-2451">
              Use Average
            </button>
          </div>
        </div>

        {/* Line of Business */}
        <div data-id="element-2452">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2453">
            Line of Business
          </label>
          <select value={selectedLineOfBusiness} onChange={e => {
          setSelectedLineOfBusiness(e.target.value);
          setSelectedClass('');
        }} className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-2454">
            <option value="" data-id="element-2455">Select a line of business</option>
            {Object.keys(lineOfBusinessData).map(lob => <option key={lob} value={lob} data-id="element-2456">
                {lob}
              </option>)}
          </select>
        </div>

        {/* Class */}
        <div data-id="element-2457">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2458">
            Class
          </label>
          <select value={selectedClass} onChange={e => setSelectedClass(e.target.value)} className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" disabled={!selectedLineOfBusiness} data-id="element-2459">
            <option value="" data-id="element-2460">Select a class</option>
            {getAvailableClasses().map((classItem, index) => {
            // Check if it's a category header
            if (classItem.startsWith('---')) {
              return <option key={index} disabled className="font-semibold bg-gray-100" data-id="element-2461">
                    {classItem.replace(/---/g, '').trim()}
                  </option>;
            }
            return <option key={index} value={classItem} data-id="element-2462">
                  {classItem}
                </option>;
          })}
          </select>
        </div>

        {/* FCA Lookup */}
        <div data-id="element-2463">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2464">FCA Lookup</h3>
          <div className="flex items-center gap-2" data-id="element-2465">
            <input type="text" placeholder="Enter MGA details" className="flex-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-2466" />
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-2467">
              Search
            </button>
          </div>
          <p className="mt-2 text-sm text-gray-500" data-id="element-2468">
            Lookup MGA details from FCA Developer API
          </p>
          <a href="#" className="mt-1 text-sm text-blue-600 hover:underline" data-id="element-2469">
            FCA Developer API
          </a>
        </div>
      </div>
    </div>;
}